/* eslint-disable react/prop-types */
import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import LoginComponent from "./LoginComponent";
import LoadingSpinner from "./utils/LoadingSpinnerComponent";
import NewPasswordForm from "./utils/NewPasswordFormComponent";
import AlertMessage from "./utils/AlertMessageComponent";
import SignInForm from "./utils/SignInFormComponent";

export default function SignInComponent() {
  const [displayNewPasswordForm, setDisplayNewPasswordForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [cognitoUser, setCognitoUser] = useState({});
  const location = useLocation();
  const [alertMessage, setAlertMessage] = useState(
    location?.state?.message || ""
  );
  const [formTitle, setFormTitle] = useState("");

  React.useEffect(() => {
    if (displayNewPasswordForm) {
      setFormTitle("First time here?");
    } else {
      setFormTitle("Log in to Athena");
    }
  }, [displayNewPasswordForm]);

  const getVisibleForm = () => {
    if (displayNewPasswordForm) {
      return (
        <NewPasswordForm
          setAlertMessage={setAlertMessage}
          cognitoUser={cognitoUser}
        />
      );
    }

    return (
      <SignInForm
        setAlertMessage={setAlertMessage}
        setIsLoading={setIsLoading}
        cognitoUser={cognitoUser}
        setCognitoUser={setCognitoUser}
        setDisplayNewPasswordForm={setDisplayNewPasswordForm}
      />
    );
  };

  return (
    <LoginComponent
      title={formTitle}
      dividerLinkTo="/forgotPassword"
      dividerLinkText="Forgot password?"
      showLinks={!isLoading}
    >
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {alertMessage && <AlertMessage message={alertMessage} />}
          {getVisibleForm()}
        </>
      )}
    </LoginComponent>
  );
}
